import myUtils from '../myUtils';
import apiConfig from './apiConfig';

const apiUrl = apiConfig.configApiUrl
const options = (method, body) => apiConfig.configOptions(method, body)
const callApi = (_url, _options) => apiConfig.configCallApi(_url, _options)

//=================== Property API =============================//
const getHomes = async ({page=0, pageSize = 100000, keyWord, homeNumber}) => {//Home // page start at 0
    let propertyId = myUtils.getUser().propertyId;
    let paging = `,"limit":${pageSize && pageSize > 0 ? pageSize : 100},"offset":${page*pageSize},"order":"homeNumber ASC"`;
    let filterHomeNumber = '';
    if(homeNumber && homeNumber != ''){
        filterHomeNumber = `,"homeNumber":"${homeNumber}"`;
    }
    let filterKeyWord = '';
    if(keyWord && keyWord != ''){
        filterKeyWord = `,"or":[{"homeNumber":{"like":"${keyWord}"}},{"name":{"like":"${keyWord}"}},{"homeAddress":{"like":"${keyWord}"}}]`;
    }
    const url = apiUrl+`/homes?filter={"where":{"active":true,"propertyId":"${propertyId}"${filterHomeNumber}${filterKeyWord}},"include":[{"relation":"user"},{"relation":"license"},{"relation":"homeMembers","scope":{"where":{"active":true},"include":[{"relation":"user"}]}}] ${paging} }`; //,"scope":{"where":{"active":true},"include":[{"releation":"user"}]}
    var resp = await callApi(url, options('GET'));

    return resp;
}

const getHomeMembersByHomeNumber = async (homeNumber) => {
    let propertyId = myUtils.getUser().propertyId;
    const url = apiUrl+`/homes?filter={"where":{"active":true,"propertyId":"${propertyId}","homeNumber":"${homeNumber}"}}`;
    var resp = await callApi(url, options('GET'));
    if(resp.status && resp.response && resp.response.length > 0){
        let home = resp.response[0];
        var respMem = await getHomeMembers(home.id);
        return respMem;
    }else{
        return resp;
    }

    
}

const getHomeMembers = async (homeId) => {
    let propertyId = myUtils.getUser().propertyId;
    let paging = `,"order":"createdAt ASC"`;
    const url = apiUrl+`/home-members?filter={"where":{"active":true,"propertyId":"${propertyId}","homeId":"${homeId}"},"include":[{"relation":"user"},{"relation":"home"}] ${paging} }`;
    var resp = await callApi(url, options('GET'));

    return resp;
}

const getAllHomeMemberActivesForProperty = async () => {
    let propertyId = myUtils.getUser().propertyId;
    const url = apiUrl+`/home-members?filter={"where":{"active":true,"homeActive":true,"propertyId":"${propertyId}"},"include":[{"relation":"user"},{"relation":"home"}]}`;
    var resp = await callApi(url, options('GET'));

    return resp;
}

const getHomeDetailByHomeNumber = async (homeNumber) => {
    let propertyId = myUtils.getUser().propertyId;
    const url = apiUrl+`/homes?filter={"where":{"active":true,"propertyId":"${propertyId}","homeNumber":"${homeNumber}"},"include":[{"relation":"user"}]}`;
    var resp = await callApi(url, options('GET'));

    return resp;
}

const getHomeMemberFromInviteCode = async (inviteCode) => {
    let propertyId = myUtils.getUser().propertyId;
    const url = apiUrl+`/home-members?filter={"where":{"active":true,"propertyId":"${propertyId}","inviteCode":"${inviteCode}"}}`;
    var resp = await callApi(url, options('GET'));

    return resp;
}

const getHomeDetail = async (homeId) => {
    const url = apiUrl+`/homes/${homeId}?filter={"include":[{"relation":"user"},{"relation":"homeMembers","scope":{"where":{"active":true},"include":[{"relation":"user"}]}}]}`;
    var resp = await callApi(url, options('GET'));

    return resp;
}

const getHomeMemberDetail = async (homeMemberId) => {
    const url = apiUrl+`/home-members/${homeMemberId}?filter={"include":[{"relation":"user"},{"relation":"home"}]}`;
    var resp = await callApi(url, options('GET'));

    return resp;
}

const createHome = async (body) => {
    const url = apiUrl+`/homes`;
    const resp = await callApi(url, options('POST', body));

    return resp;
}

const createHomeMember = async (body) => {
    const url = apiUrl+`/home-members`;
    const resp = await callApi(url, options('POST', body));

    return resp;
}

const patchHome = async (homeId, body) => {
    const url = apiUrl+`/homes/${homeId}`;
    var resp = await callApi(url, options('PATCH', body));

    return resp;
}

const patchHomeMember = async (homeMemberId, body) => {
    const url = apiUrl+`/home-members/${homeMemberId}`;
    var resp = await callApi(url, options('PATCH', body));

    return resp;
}

const patchHomeMemberByHomeId = async (homeId, body) => {
    const url = apiUrl+`/home-members?where={"active":true,"homeId":"${homeId}"}`;
    var resp = await callApi(url, options('PATCH', body));

    return resp;
}

const deleteHome = async (homeId) => {
    const url = apiUrl+`/homes/${homeId}`;
    var resp = await callApi(url, options('PATCH', {active:false}));

    return resp;
}

const deleteHomeMember = async (homeMemberId) => {
    const url = apiUrl+`/home-members/${homeMemberId}`;
    var resp = await callApi(url, options('PATCH', {active:false}));

    return resp;
}

const countHome = async ({keyWord, homeNumber}) => {
    let propertyId = myUtils.getUser().propertyId;
    let filterKeyWord = '';
    if(keyWord && keyWord != ''){
        filterKeyWord = `,"or":[{"homeNumber":{"like":"${keyWord}"}},{"name":{"like":"${keyWord}"}},{"homeAddress":{"like":"${keyWord}"}}]`;
    }
    let filterHomeNumber = '';
    if(homeNumber && homeNumber != ''){
        filterHomeNumber = `,"homeNumber":"${homeNumber}"`;
    }
    const countUrl = `${apiUrl}/homes/count?where={"active":true,"propertyId":"${propertyId}"${filterKeyWord}${filterHomeNumber}}`;
    var resp = await callApi(countUrl, options('GET'));

    return resp;
}

const countHomeActive = async ({keyWord, propertyId, companyId}) => {
    let filterKeyWord = '';
    if(keyWord && keyWord != ''){
        filterKeyWord = `,"or":[{"homeNumber":{"like":"${keyWord}"}},{"name":{"like":"${keyWord}"}},{"homeAddress":{"like":"${keyWord}"}}]`;
    }
    let filterPropertyId = '';
    if(propertyId && propertyId != ''){
        filterPropertyId = `,"propertyId": "${propertyId}"`;
    }
    let filterCompanyId = '';
    if(companyId && companyId != ''){
        filterCompanyId = `,"companyId": "${companyId}"`;
    }
    const countUrl = `${apiUrl}/homes/count?where={"active":true${filterKeyWord}${filterPropertyId}${filterCompanyId}}`;
    var resp = await callApi(countUrl, options('GET'));

    return resp;
}


export default {//HOME API
    getHomes,
    getHomeMembersByHomeNumber,
    getHomeMemberFromInviteCode,
    getHomeMembers,
    getAllHomeMemberActivesForProperty,
    getHomeDetailByHomeNumber,
    getHomeDetail,
    getHomeMemberDetail,
    createHome,
    createHomeMember,
    patchHome,
    patchHomeMember,
    patchHomeMemberByHomeId,
    deleteHome,
    deleteHomeMember,
    countHome,
    countHomeActive,
}
